import termsData from '../../components/TermsOfService/termsData';
import LegalDocument from './LegalDocument';

const TermsFullPage = () => (
  <LegalDocument
    data={termsData}
    relatedLinks={[
      { to: '/terms-summary', label: 'Plain-language summary' },
      { to: '/privacy', label: 'Privacy Policy' },
    ]}
  />
);

export default TermsFullPage;
